/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * The vehicle linked to this RFID tag, if any. Do not set when calling InsertUpdateRfidTag
 * @export
 * @interface VehicleSummary
 */
export interface VehicleSummary {
    /**
     *
     * @type {number}
     * @memberof VehicleSummary
     */
    vehicleId?: number;
    /**
     *
     * @type {string}
     * @memberof VehicleSummary
     */
    registrationPlate?: string;
    /**
     *
     * @type {string}
     * @memberof VehicleSummary
     */
    friendlyName?: string;
}

/**
 * Check if a given object implements the VehicleSummary interface.
 */
export function instanceOfVehicleSummary(
    value: object,
): value is VehicleSummary {
    return true;
}

export function VehicleSummaryFromJSON(json: any): VehicleSummary {
    return VehicleSummaryFromJSONTyped(json, false);
}

export function VehicleSummaryFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): VehicleSummary {
    if (json == null) {
        return json;
    }
    return {
        vehicleId: json["vehicleId"] == null ? undefined : json["vehicleId"],
        registrationPlate:
            json["registrationPlate"] == null
                ? undefined
                : json["registrationPlate"],
        friendlyName:
            json["friendlyName"] == null ? undefined : json["friendlyName"],
    };
}

export function VehicleSummaryToJSON(value?: VehicleSummary | null): any {
    if (value == null) {
        return value;
    }
    return {
        vehicleId: value["vehicleId"],
        registrationPlate: value["registrationPlate"],
        friendlyName: value["friendlyName"],
    };
}
